import { render, staticRenderFns } from "./faq-vue-mobile.vue?vue&type=template&id=24174b60&scoped=true"
import script from "./faq-vue-mobile.vue?vue&type=script&lang=js"
export * from "./faq-vue-mobile.vue?vue&type=script&lang=js"
import style0 from "./faq-vue-mobile.vue?vue&type=style&index=0&id=24174b60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24174b60",
  null
  
)

export default component.exports